import React, { Component } from "react";
import PropTypes from "prop-types";
import * as THREE from "three";

class PlayerCamera extends Component {
  constructor(props, context) {
    super(props, context);
    this.fps = 60;
    this.gamma = parseFloat(this.props.gamma);
    this.phi = THREE.Math.clamp(parseFloat(this.props.phi), -90, 90);
    this.theta = parseFloat(this.props.theta);
    this.fov = parseFloat(this.props.fov);

    this.state = {
      rotation: new THREE.Euler(
        THREE.Math.degToRad(this.phi),
        THREE.Math.degToRad(this.theta),
        THREE.Math.degToRad(this.gamma),
        "YXZ"
      ),
      fov: this.fov
    };

    this.loop = this.loop.bind(this);
  }

  componentDidMount() {
    this.startLoop();
    this.props.cameraRef(this.perspectiveCamera);
    this.onMove();
  }

  componentWillUnmount() {
    this.stopLoop();
  }

  startLoop() {
    if (!this.frameId) {
      this.frameId = window.requestAnimationFrame(this.loop);
    }
  }

  loop() {
    this.update();
    this.frameId = window.requestAnimationFrame(this.loop);
  }

  stopLoop() {
    window.cancelAnimationFrame(this.frameId);
  }

  update() {
    const startE = this.state.rotation;
    const endE = new THREE.Euler(
      THREE.Math.degToRad(this.props.phi),
      THREE.Math.degToRad(this.props.theta),
      THREE.Math.degToRad(this.props.gamma),
      "YXZ"
    );
    const startQ = new THREE.Quaternion();
    const endQ = new THREE.Quaternion();
    startQ.setFromEuler(startE);
    endQ.setFromEuler(endE);
    const targetQ = new THREE.Quaternion();
    THREE.Quaternion.slerp(startQ, endQ, targetQ, 1 / this.props.delay);
    const targetE = new THREE.Euler().setFromQuaternion(targetQ, "YXZ");

    const startFov = this.state.fov;
    const endFov = this.props.fov;
    const targetFov = THREE.Math.lerp(startFov, endFov, 1 / this.props.delay);
    if (
      this.state.rotation.x != targetE.x ||
      this.state.rotation.y != targetE.y ||
      this.state.rotation.z != targetE.z ||
      this.state.fov != targetFov ||
      true
    ) {
      this.onMove();
    }
    this.setState({
      rotation: targetE,
      fov: targetFov
    });
  }

  onMove() {
    const { onMove } = this.props;
    if (onMove) {
      onMove(this.state.rotation, this.state.fov);
    }
    this.props.cameraRef(this.perspectiveCamera);
  }

  render() {
    return (
      <perspectiveCamera
        ref={component => {
          this.perspectiveCamera = component;
        }}
        name="camera"
        near={0.1}
        far={1000}
        aspect={this.props.aspect}
        fov={this.state.fov}
        rotation={this.state.rotation}
      />
    );
  }
}

PlayerCamera.propTypes = {
  gamma: PropTypes.number,
  phi: PropTypes.number,
  theta: PropTypes.number,
  delay: PropTypes.number,
  fov: PropTypes.number,
  aspect: PropTypes.number,
  onMove: PropTypes.func
};

export default PlayerCamera;



// WEBPACK FOOTER //
// ./src/components/Player/PlayerCamera/PlayerCamera.js